import {
  Container,
  Card,
  Button,
  Row,
  Col,
  Form,
  DropdownButton,
  Dropdown,
  Alert,
} from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { getAuth, signInWithEmailAndPassword, signOut } from "firebase/auth";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCompactDisc, faGuitar } from "@fortawesome/free-solid-svg-icons";
import "bootstrap/dist/css/bootstrap.min.css";
import { useState, useEffect } from "react";
import {
  getFirestore,
  doc,
  collection,
  onSnapshot,
  getDocs,
  getDoc,
  updateDoc,
  addDoc,
  query,
  Timestamp,
  arrayUnion,
  where,
  serverTimestamp,
} from "firebase/firestore";

import { initializeApp } from "firebase/app";
import { useCollection } from "react-firebase-hooks/firestore";
import { useAuthState } from "react-firebase-hooks/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBBzepSPN2wdZfvan5GgyeeIREAV6k5BaU",
  authDomain: "loftie-4f472.firebaseapp.com",
  databaseURL: "https://loftie-4f472.firebaseio.com",
  projectId: "loftie-4f472",
  storageBucket: "loftie-4f472.appspot.com",
  messagingSenderId: "302939981606",
  appId: "1:302939981606:web:7fcb10ed6fe46fa437a3e7",
  measurementId: "G-L8VGQXX28P",
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
const auth = getAuth(firebaseApp);
const cors = require("cors");
const client = getFirestore(firebaseApp);

function AudioCenter() {
  const [user, userLoading] = useAuthState(auth);
  const [showTrackForm, setShowTrackForm] = useState(false);
  const [showAlbumForm, setShowAlbumForm] = useState(false);
  const [genre, setGenre] = useState(null);
  const [album, setAlbum] = useState(null);
  const [trackTitle, setTrackTitle] = useState("");
  const [audioUrl, setAudioUrl] = useState("");
  const [contentSaved, setContentSaved] = useState(false);
  const [addToClock, setAddToClock] = useState(false);
  const [clockAlbum, setClockAlbum] = useState(null);
  const [albumTitle, setAlbumTitle] = useState(null);
  const [albumCover, setAlbumCover] = useState("");
  const [description, setDescription] = useState("");
  const [creatorName, setCreatorName] = useState("");
  const [creatorBio, setCreatorBio] = useState("");
  const [creatorHeadshot, setCreatorHeadshot] = useState("");
  const [yourNextListenAlbumCategories, setYourNextListenAlbumCategories] =
    useState([]);
  const [yourNextListenAlbums, setYourNextListenAlbums] = useState([]);
  const [storymakerAlbums, setStorymakerAlbums] = useState([]);
  const [storymakerCategories, setStorymakerCategories] = useState([]);
  const [sendAtDate, setSendAtDate] = useState(new Date());
  const [isNewTrack, setIsNewTrack] = useState(false);
  const [isNewAlbum, setIsNewAlbum] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [showCreatorInputs, setShowCreatorInputs] = useState(false);
  const [showSavedAlert, setShowSavedAlert] = useState(false);
  const [clockTitle, setClockTitle] = useState("");
  const [audioMins, setAudioMins] = useState("0");
  const [audioSecs, setAudioSecs] = useState("0");
  const [addAlbumDate, setAddAlbumDate] = useState(new Date());

  const handleCheck = (category) => {
    setSelectedCategories((prevSelected) => {
      if (prevSelected.includes(category)) {
        return prevSelected.filter((item) => item !== category); // Deselect if already selected
      }
      return [...prevSelected, category]; // Add to selected if not selected
    });
  };

  const handleNewTrack = async () => {
    const totalLength =
      parseInt(audioMins, 10) * 60 + parseInt(audioSecs, 10) || 0;

    const ref = await getAlbumReference(album);

    const newTrackData = {
      title: trackTitle,
      clockTitle: clockTitle,
      source: audioUrl,
      albumRef: ref,
      sendAtDate: Timestamp.fromDate(sendAtDate),
      created_at: serverTimestamp(),
      length: totalLength,
      looping: false,
      addedTrack: false,
    };

    try {
      await addDoc(collection(client, "audio-tracks"), newTrackData);
      setShowSavedAlert(true);
    } catch (error) {
      console.log("error adding new track", error);
    }
    setTrackTitle("");
    setClockTitle("");
    setAudioUrl("");
    setAudioMins("0");
    setAudioSecs("0");
    setAlbum(null);
    setGenre("");
  };

  const handleNewAlbum = async () => {
    const genreRef = genreDocIdMap[genre]
      ? doc(client, "audio-genre", genreDocIdMap[genre])
      : null;

    const newAlbumData = {
      title: albumTitle,
      description,
      "album-cover": albumCover,
      "about-creator": creatorBio,
      creator: creatorName,
      storymakerCategories: selectedCategories,
      addedAlbum: false,
      addAtDate: addAlbumDate,
      genreRef: genreRef,
    };
    await createAudioAlbumDocument(newAlbumData, genreRef);
    setShowSavedAlert(true);
    setAlbumTitle("");
    setDescription("");
    setAlbumCover("");
    setCreatorName("");
    setCreatorBio("");
    setCreatorHeadshot("");
    setSelectedCategories([]);
    setShowCreatorInputs(false);
    setGenre(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    isNewTrack && handleNewTrack();
    isNewAlbum && handleNewAlbum();
  };

  const createAudioAlbumDocument = async (albumData, genreRef) => {
    const albumRef = await addDoc(collection(client, "audio-album"), albumData);

    const albumDocRef = doc(client, "audio-album", albumRef.id);

    await updateDoc(albumRef, { documentRef: albumDocRef });
  };

  const genres = ["Storymaker", "Your next listen"];
  const genreDocIdMap = {
    "Your next listen": "ZlURSeTll2XZl1TQ9mQR",
    Storymaker: "7oirTkO2DLZrZGcPUkqJ",
  };

  useEffect(() => {
    // Only fetch data if user is authenticated
    if (!user) return;

    const yourNextListenRef = doc(
      collection(client, "audio-genre"),
      "ZlURSeTll2XZl1TQ9mQR"
    );
    const unsubscribe = onSnapshot(yourNextListenRef, async (doc) => {
      if (doc.exists()) {
        const yourNextListenDocData = doc.data();
        const listenCategories = yourNextListenDocData["categoryOrder"];
        setYourNextListenAlbumCategories(listenCategories);

        const albumRefs = yourNextListenDocData["albums"].map(
          (album) => album.albumRef
        );
        await getYourNextListenAlbums(albumRefs);
      }
    });

    return () => unsubscribe();
  }, [user]);

  const getYourNextListenAlbums = async (albumRefs) => {
    const albumTitles = [];
    for (let albumRef of albumRefs) {
      const albumDoc = await getDoc(
        doc(collection(client, "audio-album"), albumRef.id)
      );
      if (albumDoc.exists()) {
        const albumData = albumDoc.data();
        const albumTitle = albumData["title"];
        albumTitles.push(albumTitle);
      }
    }
    setYourNextListenAlbums(albumTitles);
  };

  useEffect(() => {
    // Only fetch data if user is authenticated
    if (!user) return;

    const storymakerGenreDocRef = doc(
      collection(client, "audio-genre"),
      "7oirTkO2DLZrZGcPUkqJ"
    );
    const unsubscribe = onSnapshot(storymakerGenreDocRef, async (doc) => {
      if (doc.exists()) {
        const storymakerDocData = doc.data();
        const storymakerCategories = storymakerDocData["categoryOrder"];
        setStorymakerCategories(storymakerCategories);

        const albumRefs = storymakerDocData["albums"].map(
          (album) => album.albumRef
        );
        await getStorymakerAlbums(albumRefs);
      }
    });

    return () => unsubscribe();
  }, [user]);

  const getStorymakerAlbums = async (albumRefs) => {
    const albumTitles = [];
    for (let albumRef of albumRefs) {
      const albumDoc = await getDoc(
        doc(collection(client, "audio-album"), albumRef.id)
      );
      if (albumDoc.exists()) {
        const albumData = albumDoc.data();
        const albumTitle = albumData["title"];
        albumTitles.push(albumTitle);
      }
    }
    setStorymakerAlbums(albumTitles);
  };

  let albumList = [];
  if (genre == "Storymaker") {
    albumList = storymakerAlbums;
  } else if (genre == "Your next listen") {
    albumList = yourNextListenAlbums;
  }

  const loftiePlusClockAlbums = [
    "Storymaker",
    "Long Stories",
    "Short Stories",
    "Books",
    "Poems",
  ];

  const getAlbumReference = async (album) => {
    const albumQuery = query(
      collection(client, "audio-album"),
      where("title", "==", album)
    );
    try {
      const querySnapshot = await getDocs(albumQuery);
      if (!querySnapshot.empty) {
        const doc = querySnapshot.docs[0];
        return doc.ref;
      } else {
        console.log("no doc found");
      }
    } catch (error) {
      console.log("error at getting album reference", error);
    }
  };

  if (userLoading) {
    return (
      <Container className="d-flex justify-content-center align-items-center mt-5">
        <h3>Loading...</h3>
      </Container>
    );
  }

  if (!user) {
    return (
      <Container className="d-flex justify-content-center align-items-center mt-5">
        <h3>Authentication Required</h3>
      </Container>
    );
  }

  return (
    <Container>
      <Spacer height={45} />
      <h1 className="text-center mb-4" style={{ color: "#F0D6B5" }}>
        Audio Center
      </h1>
      <Row className="mt-4 g-4 justify-content-center">
        <Col md={5}>
          <Card
            className="text-center"
            onClick={() => {
              setShowAlbumForm(!showAlbumForm);
              setShowTrackForm(false);
              setIsNewAlbum(true);
              setIsNewTrack(false);
            }}
          >
            <Card.Body>
              <FontAwesomeIcon
                icon={faCompactDisc}
                size="3x"
                style={iconStyle}
              />
              <Card.Title>New Audio Album</Card.Title>
            </Card.Body>
          </Card>
        </Col>
        <Col md={5}>
          <Card
            className="text-center"
            onClick={() => {
              setShowAlbumForm(false);
              setIsNewTrack(true);
              setShowTrackForm(!showTrackForm);
              setIsNewAlbum(false);
            }}
          >
            <Card.Body>
              <FontAwesomeIcon icon={faGuitar} size="3x" style={iconStyle} />
              <Card.Title>New Audio Track</Card.Title>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {showSavedAlert && (
        <Alert
          variant="info"
          onClose={() => setShowSavedAlert(false)}
          dismissible
          className="position-fixed top-0 start-50 translate-middle-x mt-3"
          style={{ zIndex: 1050 }}
        >
          <Alert.Heading>Yay!</Alert.Heading>
          <p>Your content has been saved successfully.</p>
        </Alert>
      )}
      {showTrackForm && (
        <Row>
          <Form
            onSubmit={handleSubmit}
            className="p-4 bg-white rounded shadow-lg w-75 mx-auto"
          >
            <Form.Label className=" text-dark">
              Create new audio track
            </Form.Label>
            <div>
              <Row className="mb-3">
                <Col>
                  <DropdownButton
                    id="dropdown-custom-components"
                    title={genre || "Select genre"}
                    onSelect={(selectedValue) => {
                      setGenre(selectedValue);
                    }}
                    variant="outline-secondary"
                  >
                    {genres.map((genre, index) => (
                      <Dropdown.Item key={index} eventKey={genre} title={genre}>
                        {genre}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                </Col>

                {genre && (
                  <Col>
                    <DropdownButton
                      id="dropdown-custom-components"
                      title={album || "Select album"}
                      onSelect={(selectedValue) => {
                        setAlbum(selectedValue);
                      }}
                      variant="outline-secondary"
                    >
                      {albumList.map((album, index) => (
                        <Dropdown.Item
                          key={index}
                          eventKey={album}
                          title={album}
                        >
                          {album}
                        </Dropdown.Item>
                      ))}
                    </DropdownButton>
                  </Col>
                )}
              </Row>

              {genre && (
                <div>
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group controlId="title" className="mb-3">
                        <Form.Label className="text-dark">
                          Track Title
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter title"
                          value={trackTitle}
                          onChange={(e) => setTrackTitle(e.target.value)}
                          className="bg-white text-dark"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group controlId="clockTitle" className="mb-3">
                        <Form.Label className="text-dark">
                          Clock Title Title
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Clock title"
                          value={clockTitle}
                          onChange={(e) => setClockTitle(e.target.value)}
                          className="bg-white text-dark"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row className="mb-3">
                    <Col md={6}>
                      <Form.Group controlId="audioUrl" className="mb-3">
                        <Form.Label className="text-dark">Audio Url</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Paste the Audio Url"
                          value={audioUrl}
                          onChange={(e) => setAudioUrl(e.target.value)}
                          className="bg-white text-dark"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="audioMins" className="mb-3">
                        <Form.Label className="text-dark">
                          Audio Minutes
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Audio Minutes"
                          value={audioMins}
                          onChange={(e) => setAudioMins(e.target.value)}
                          className="bg-white text-dark"
                        />
                      </Form.Group>
                    </Col>
                    <Col md={3}>
                      <Form.Group controlId="audioSecs" className="mb-3">
                        <Form.Label className="text-dark">
                          Audio Seconds
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Audio Seconds"
                          value={audioSecs}
                          onChange={(e) => setAudioSecs(e.target.value)}
                          className="bg-white text-dark"
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Label className="text-dark">
                        Schedule Time
                      </Form.Label>
                      <DatePicker
                        selected={sendAtDate}
                        onChange={(date) => setSendAtDate(date)}
                        dateFormat="MMMM d, yyyy"
                        className="form-control"
                        style={{ backgroundColor: "#fff", color: "#000" }}
                      />
                    </Col>
                  </Row>
                  {addToClock && genre == "Your next listen" && (
                    <Col>
                      <DropdownButton
                        id="dropdown-custom-components"
                        title={clockAlbum || "Select Clock Album"}
                        onSelect={(selectedValue) => {
                          setClockAlbum(selectedValue);
                        }}
                        variant="outline-secondary"
                      >
                        {loftiePlusClockAlbums.map((clockAlbum, index) => (
                          <Dropdown.Item
                            key={index}
                            eventKey={clockAlbum}
                            title={clockAlbum}
                          >
                            {clockAlbum}
                          </Dropdown.Item>
                        ))}
                      </DropdownButton>
                    </Col>
                  )}
                  <br />

                  <Button
                    variant="outline"
                    type="submit"
                    className="w-100"
                    style={{
                      backgroundColor: "#F0D6B5",
                      borderColor: "#F0D6B5",
                      color: "black",
                    }}
                  >
                    {contentSaved ? "Content Saved" : "Save"}
                  </Button>
                </div>
              )}
            </div>
          </Form>
        </Row>
      )}
      {showAlbumForm && (
        <Row>
          <Form
            onSubmit={handleSubmit}
            className="p-4 bg-white rounded shadow-lg w-75 mx-auto"
          >
            <Form.Label className=" text-dark">
              Create new audio album
            </Form.Label>
            <div>
              <Row className="mb-3">
                <Col>
                  <DropdownButton
                    id="dropdown-custom-components"
                    title={genre || "Select genre"}
                    onSelect={(selectedValue) => {
                      setGenre(selectedValue);
                    }}
                    variant="outline-secondary"
                  >
                    {genres.map((genre, index) => (
                      <Dropdown.Item key={index} eventKey={genre} title={genre}>
                        {genre}
                      </Dropdown.Item>
                    ))}
                  </DropdownButton>
                </Col>

                {genre == "Your next listen" && (
                  <Col>
                    <Dropdown onToggle={(isOpen) => isOpen} autoClose="outside">
                      <Dropdown.Toggle
                        variant="outline-secondary"
                        id="dropdown-custom-components"
                      >
                        {selectedCategories.length > 0
                          ? `${selectedCategories.length} Categories Selected`
                          : "Select Categories"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {yourNextListenAlbumCategories.map(
                          (category, index) => (
                            <Dropdown.Item key={index} as="div">
                              <label
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  width: "100%",
                                  padding: "5px 10px",
                                }}
                                onClick={(e) => e.stopPropagation()} // Prevents the dropdown from closing
                              ></label>
                              <input
                                type="checkbox"
                                checked={selectedCategories.includes(category)}
                                onChange={() => handleCheck(category)}
                                style={{
                                  marginRight: "10px",
                                  accentColor: "#F0D6B5",
                                }}
                              />
                              {category}
                            </Dropdown.Item>
                          )
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                )}
                {genre == "Storymaker" && (
                  <Col>
                    <Dropdown onToggle={(isOpen) => isOpen} autoClose="outside">
                      <Dropdown.Toggle
                        variant="outline-secondary"
                        id="dropdown-basic"
                      >
                        {selectedCategories.length > 0
                          ? `${selectedCategories.length} Categories Selected`
                          : "Select Categories"}
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        {storymakerCategories.map((category, index) => (
                          <Dropdown.Item key={index} as="div">
                            <label
                              style={{
                                display: "flex",
                                alignItems: "center",
                                cursor: "pointer",
                                width: "100%",
                                padding: "5px 10px",
                              }}
                              onClick={(e) => e.stopPropagation()} // Prevents the dropdown from closing
                            ></label>
                            <input
                              type="checkbox"
                              checked={selectedCategories.includes(category)}
                              onChange={() => handleCheck(category)}
                              style={{
                                marginRight: "10px",
                                accentColor: "#F0D6B5",
                              }}
                            />
                            {category}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown>
                  </Col>
                )}
              </Row>

              {genre && (
                <div>
                  <Form.Group controlId="title" className="mb-3">
                    <Form.Label className="text-dark">Album Title</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter title"
                      value={albumTitle}
                      onChange={(e) => setAlbumTitle(e.target.value)}
                      className="bg-white text-dark"
                    />
                  </Form.Group>
                  <Form.Group controlId="description" className="mb-3">
                    <Form.Label className="text-dark">
                      Album Description
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Add album description"
                      value={description}
                      onChange={(e) => setDescription(e.target.value)}
                      className="bg-white text-dark"
                    />
                  </Form.Group>
                  <Form.Group controlId="albumCover" className="mb-3">
                    <Form.Label className="text-dark">Album Cover</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Paste the Audio Cover"
                      value={albumCover}
                      onChange={(e) => setAlbumCover(e.target.value)}
                      className="bg-white text-dark"
                    />
                  </Form.Group>
                  <Form.Group controlId="image" className="mb-3">
                    <div
                      style={{ display: "inline-block", marginRight: "10px" }}
                    >
                      <Form.Check
                        type="checkbox"
                        label="Include Author"
                        checked={showCreatorInputs}
                        onChange={(e) => setShowCreatorInputs(e.target.checked)}
                        className="custom-checkbox"
                      />
                    </div>
                    <br />
                    {showCreatorInputs && (
                      <div>
                        <Form.Control
                          type="text"
                          placeholder="Enter creator name"
                          value={creatorName}
                          onChange={(e) => setCreatorName(e.target.value)}
                          className="bg-white text-dark"
                        />
                        <br />
                        <Form.Control
                          type="text"
                          placeholder="Enter creator bio"
                          value={creatorBio}
                          onChange={(e) => setCreatorBio(e.target.value)}
                          className="bg-white text-dark"
                        />
                        <br />
                        <Form.Control
                          type="text"
                          placeholder="Enter creator headshot"
                          value={creatorHeadshot}
                          onChange={(e) => setCreatorHeadshot(e.target.value)}
                          className="bg-white text-dark"
                        />
                      </div>
                    )}
                  </Form.Group>
                  <Form.Label className="text-dark">Schedule Time</Form.Label>
                  <DatePicker
                    selected={addAlbumDate}
                    onChange={(date) => setAddAlbumDate(date)}
                    dateFormat="MMMM d, yyyy"
                    className="form-control"
                    style={{ backgroundColor: "#fff", color: "#000" }}
                  />
                  <Button
                    variant="outline"
                    type="submit"
                    className="w-100"
                    style={{
                      backgroundColor: "#F0D6B5",
                      borderColor: "#F0D6B5",
                      color: "black",
                    }}
                  >
                    {contentSaved ? "Content Saved" : "Save"}
                  </Button>
                </div>
              )}
            </div>
          </Form>
        </Row>
      )}
    </Container>
  );
}

const iconStyle = {
  color: "#F0D6B5",
};
const Spacer = ({ width, height }) => {
  return <div style={{ width: width || 1, height: height || 1 }}></div>;
};
export default AudioCenter;
